import {Helmet} from '@dr.pogodin/react-helmet';
import {openDeleteDialog} from 'platform/components';
import {match} from 'ts-pattern';

import {always} from 'ramda';
import {isArray} from 'ramda-adjunct';

import {useDeleteMeasurementUnitLabourOperationMutation} from '@dms/api/workshop';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';
import {DmsDataGrid, handleApiError} from '@dms/shared';

import {composePath, useNavigate} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

export function WorkshopMeasurementUnits() {
  const navigate = useNavigate();

  const [deleteMeasurementUnitLabourOperation] = useDeleteMeasurementUnitLabourOperationMutation();

  const actionCallback: ActionCallback = ({actionKey, rowId, refreshData}) => {
    const id = isArray(rowId) ? rowId[0] : rowId;

    match(actionKey)
      .with('redirectDetail', 'edit', () =>
        navigate(composePath(settingsRoutes.workshopMeasurementUnitDetail, {params: {id}}))
      )
      .with('delete', () =>
        openDeleteDialog({
          onConfirm: () =>
            deleteMeasurementUnitLabourOperation({muloId: id})
              .unwrap()
              .then(() => refreshData())
              .catch(handleApiError),
        })
      )
      .otherwise(always(undefined));
  };

  return (
    <>
      <Helmet title={i18n.t('page.settings.labels.measurementUnits')} />
      <SettingsTemplate
        header={{
          title: i18n.t('page.settings.labels.measurementUnits'),
          actions: [
            {
              type: 'button',
              title: i18n.t('page.settings.actions.newMeasurementUnit'),
              onClick: () => navigate(settingsRoutes.workshopMeasurementUnitCreate),
            },
          ],
        }}
        data-testid={testIds.settings.workshopMeasurementUnits('template')}
      >
        <DmsDataGrid gridCode="measurement-unit-labour-operation" actionCallback={actionCallback} />
      </SettingsTemplate>
    </>
  );
}
